import React from 'react'
import { HightLight, Text } from '../gameRulesStyle'
import Scores from './elements/Scores'
// import
export default function ScoreBoard() {
  return (
    <>
      <HightLight fontSize='22px' background='blue' margin={'15px 0 0'}>
        {' '}
        ScoreBoard
      </HightLight>
      <Text margin={'15px 0'}>
        SHOWS PREDICTION NUMBER ON THE LEFT SIDE WITH REFERENCE COLOR OF{' '}
        <HightLight fontSize='18px' background='red'>
          ROLL UNDER
        </HightLight>{' '}
        /
        <HightLight fontSize='18px' background='blue'>
          ROLL OVER
        </HightLight>
      </Text>
      <Text margin={'15px 0'}>
        ON THE RIGHT SIDE IT SHOWS{' '}
        <HightLight fontSize='18px' background='blue'>
          CYBERSCORE
        </HightLight>{' '}
        THAT MEANS RESULT OF THE GAME WITH ITS REFERED COLOR.
      </Text>
      <Text margin={'15px 0'}>
        IT HAS BOTTOM “TRAIN” THAT SHOWS RECENT 6 ROLLS (BETS) AND HAS GAME{' '}
        <HightLight fontSize='18px' background='blue'>
          HISTORY BUTTON
        </HightLight>{' '}
        FOR MORE RESULTS.
      </Text>
      <Scores />
    </>
  )
}
